import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "Components/Hooks/hooks";
import { redirectPage } from "utils/redirectPage";

const AuthProtected = ({ children }: any) => {
  const user = useAppSelector((state) => state?.auth?.user);
  const location = useLocation();
  const correctRoute = redirectPage(user, true);

  if (!user?.access_token) {
    return <Navigate to="/login" replace />;
  }

  if (
    correctRoute &&
    location.pathname !== correctRoute &&
    user?.role !== "admin"
  ) {
    return <Navigate to={correctRoute} replace />;
  }

  return children;
};

export default AuthProtected;
